
export const LanguageSkills = [
    {
        id: 1,
        name: 'React.js',
        imgURL: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original.svg'
    }, {
        id: 2,
        name: 'Next.js',
        imgURL: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/nextjs/nextjs-original.svg'
    }, {
        id: 3,
        name: 'JavaScript',
        imgURL: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-original.svg'
    }, {
        id: 4,
        name: 'Typescript',
        imgURL: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg'
    }, {
        id: 5,
        name: 'Node.js',
        imgURL: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original.svg'
    }, {
        id: 6,
        name: 'Express.js',
        imgURL: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/express/express-original.svg'
    }, {
        id: 7,
        name: 'MongoDB',
        imgURL: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original.svg'
    }, {
        id: 8,
        name: 'MySQL',
        imgURL: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg'
    }, {
        id: 9,
        name: 'Supabase',
        imgURL: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/supabase/supabase-original.svg'
    }, {
        id: 10,
        name: 'Tailwind CSS',
        imgURL: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/tailwindcss/tailwindcss-original-wordmark.svg'
    }, {
        id: 11,
        name: 'Bootstrap',
        imgURL: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/bootstrap/bootstrap-original.svg'
    }, {
        id: 12,
        name: 'Java',
        imgURL: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg'
    }, {
        id: 13,
        name: 'Python',
        imgURL: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg'
    },
]